// extracted by mini-css-extract-plugin
export default {"header":"lgvUXUqw1mo8w4QE3vPo","no-results":"Btsbzo5eYPBLMWWvrnNt","noResults":"Btsbzo5eYPBLMWWvrnNt","spacing":"_6BrleXK5I9luz5N5Do9T"};